





































import { defineComponent, ref, watch } from '@vue/composition-api';
import { snackbar } from '@/components/GlobalSnackbar';
import { changePasswordMenu as active, mustChangePassword as must } from './state';
import { useClient } from '@/use';
import UserPassword from '@/components/UserPassword.vue';

export default defineComponent({
  name: 'ChangePasswordMenu',
  components: { UserPassword },
  setup(props, ctx) {
    const client = useClient();

    const formValid = ref(false);
    const commonRules = [
      (val: string | number | null) => (!!val || 'Field cannot be empty'),
    ];

    const oldPassword = ref<string | null>(null);
    const oldPasswordError = ref<string | null>(null);

    // Reset error message once value is changed
    watch(oldPassword, () => { oldPasswordError.value = null; });

    const newPassword = ref<string | null>(null);

    const updatePW = (val: string) => {
      newPassword.value = val;
    };

    function closeMenu() {
      ctx.emit('close');
    }

    async function changePassword() {
      if (
        !oldPassword.value
        || !newPassword.value
      ) { return; }

      const payload = {
        old_password: oldPassword.value,
        new_password: newPassword.value,
      };

      const resp = await client.changePassword(payload);
      if (resp === false) {
        oldPasswordError.value = 'Incorrect password';
        return;
      }

      closeMenu();
      snackbar.dispatch({ text: 'Password Successfully Changed' });
    }

    return {
      active,
      must,
      formValid,
      commonRules,
      oldPassword,
      oldPasswordError,
      closeMenu,
      changePassword,
      UserPassword,
      updatePW,
    };
  },
});
